export default "__VITE_ASSET__7pIayklW__"